import { CHANGE_TITLE } from './types'

export const changeTitle = (title) => {
  return {
    type: CHANGE_TITLE,
    payload: title,
  }
}
